const cs = {
  auth: {
    login: 'Přihlásit',
    loggingIn: 'Přihlašování…',
    loginWithNetlifyIdentity: 'Přihlásit pomocí Netlify Identity',
    loginWithAzure: 'Přihlásit pomocí Azure',
    loginWithBitbucket: 'Přihlásit pomocí Bitbucket',
    loginWithGitHub: 'Přihlásit pomocí GitHub',
    loginWithGitLab: 'Přihlásit pomocí GitLab',
    loginWithGitea: 'Přihlásit pomocí Gitea',
    errors: {
      email: 'Vyplňte e-mailovou adresu.',
      password: 'Vyplňte heslo.',
      identitySettings: 'Nastavení identity nenalezeno. Používáte-li git-gateway server nezapomeňte aktivovat službu Identity a Git Gateway' + '.'
    }
  },
  app: {
    header: {
      content: 'Obsah',
      workflow: 'Schvalování',
      media: 'Média',
      quickAdd: 'Přidat'
    },
    app: {
      errorHeader: 'Chyba při načítání CMS konfigurace',
      configErrors: 'Chyba konfigurace',
      checkConfigYml: 'Zkontrolujte soubor config.yml.',
      loadingConfig: 'Načítání konfigurace…',
      waitingBackend: 'Čekání na server…'
    },
    notFoundPage: {
      header: 'Nenalezeno'
    }
  },
  collection: {
    sidebar: {
      collections: 'Kolekce',
      allCollections: 'Všechny kolekce',
      searchAll: 'Hledat',
      searchIn: 'Hledat v'
    },
    collectionTop: {
      sortBy: 'Seřadit podle',
      viewAs: 'Zobrazit jako',
      newButton: 'Přidat',
      ascending: 'Vzestupné',
      descending: 'Sestupné',
      searchResults: 'Výsledky vyhledávání pro "%{searchTerm}"',
      searchResultsInCollection: 'Výsledky vyhledávání pro "%{searchTerm}" v kolekci %{collection}',
      filterBy: 'Filtrovat podle',
      groupBy: 'Seskupit podle'
    },
    entries: {
      loadingEntries: 'Načítání položek',
      cachingEntries: 'Úkládání položek do mezipaměti',
      longerLoading: 'Načítání může trvat několik minut',
      noEntries: 'Žádné položky'
    },
    groups: {
      other: 'Ostatní',
      negateLabel: 'Není %{label}'
    },
    defaultFields: {
      author: {
        label: 'Autor'
      },
      updatedOn: {
        label: 'Poslední aktualizace'
      }
    }
  },
  editor: {
    editorControl: {
      field: {
        optional: 'volitelný'
      }
    },
    editorControlPane: {
      widget: {
        required: '%{fieldLabel} je povinný.',
        regexPattern: '%{fieldLabel} nesouhlasí s předepsaným vzorem: %{pattern}.',
        processing: '%{fieldLabel} se zpracovává.',
        range: '%{fieldLabel} musí být mezi %{minValue} a %{maxValue}.',
        min: '%{fieldLabel} musí být alespoň %{minValue}.',
        max: '%{fieldLabel} musí být %{maxValue} nebo méně.',
        rangeCount: '%{fieldLabel} musí mít %{minCount} až %{maxCount} položek.',
        rangeCountExact: '%{fieldLabel} musí mít přesně %{count} položek.',
        rangeMin: '%{fieldLabel} musí mít nejméně %{minCount} položky.',
        rangeMax: '%{fieldLabel} musí mít %{maxCount} nebo méně položek.',
        invalidPath: `'%{path}' není platnou cestou.`,
        pathExists: `Cesta '%{path}' už existuje.`
      },
      i18n: {
        writingInLocale: 'Psát v %{locale}',
        copyFromLocale: 'Vyplnit z jiného jazyka',
        copyFromLocaleConfirm: 'Chcete vyplnit data z jazyka %{locale}?\nVeškerý současný obsah bude přepsán.'
      }
    },
    editor: {
      onLeavePage: 'Opravdu chcete opustit tuto stránku?',
      onUpdatingWithUnsavedChanges: 'Máte neuložené změny. Před změnou stavu je prosím uložte.',
      onPublishingNotReady: 'Změňte stav na „Připraveno“ před publikováním.',
      onPublishingWithUnsavedChanges: 'Máte neuložené změny, před publikováním je prosím uložte.',
      onPublishing: 'Opravdu chcete publikovat tuto položku?',
      onUnpublishing: 'Opravdu chcete zrušit publikování této položky?',
      onDeleteWithUnsavedChanges: 'Opravdu chcete vymazat tuto publikovanou položku a všechny neuložené změny z této relace?',
      onDeletePublishedEntry: 'Opravdu chcete smazat tuto publikovanou položku?',
      onDeleteUnpublishedChangesWithUnsavedChanges: 'Tato akce vymaže všechny nepublikované změny v této položce a také všechny neuložené změny z této relace. Chcete položku skutečně vymazat?',
      onDeleteUnpublishedChanges: 'Všechny nepublikované změny v této položce budou vymazány. Chcete ji skuteně vymazat?',
      loadingEntry: 'Načítání položky…',
      confirmLoadBackup: 'Lokální kopie této položky byla nalezena, chcete ji použít?'
    },
    editorInterface: {
      toggleI18n: 'Přepnout lokalizaci',
      togglePreview: 'Přepnout náhled',
      toggleScrollSync: 'Sladit skrolování'
    },
    editorToolbar: {
      publishing: 'Publikování…',
      publish: 'Publikovat',
      published: 'Publikovaný',
      unpublish: 'Zrušit publikování',
      duplicate: 'Duplikovat',
      unpublishing: 'Rušení publikování…',
      publishAndCreateNew: 'Publikovat a vytvořit nový',
      publishAndDuplicate: 'Publikovat a duplikovat',
      deleteUnpublishedChanges: 'Vymazat nepublikované změny',
      deleteUnpublishedEntry: 'Vymazat nepublikovanou položku',
      deletePublishedEntry: 'Vymazat publikovanou položku',
      deleteEntry: 'Vymazat položku',
      saving: 'Ukládání…',
      save: 'Uložit',
      statusInfoTooltipDraft: 'Položka je ve stavu konceptu. Po dokončení úprav ji označte stavem ‚V revizi‘.',
      statusInfoTooltipInReview: 'Položka je označena jako připravená k revizi, žádná další akce není třeba. Můžete ovšem provádět další změny, zatímco probíhá revize.',
      deleting: 'Vymazávání…',
      updating: 'Aktualizace…',
      status: 'Stav: %{status}',
      backCollection: ' Píšete v kolekci %{collectionLabel}',
      unsavedChanges: 'Neuložené změny',
      changesSaved: 'Změny uloženy',
      draft: 'Koncept',
      inReview: 'V revizi',
      ready: 'Připraveno',
      publishNow: 'Publikovat teď',
      deployPreviewPendingButtonLabel: 'Zkontrolovat náhled',
      deployPreviewButtonLabel: 'Zobrazit náhled',
      deployButtonLabel: 'Zobrazit na webu'
    },
    editorWidgets: {
      markdown: {
        bold: 'Tučně',
        italic: 'Kurzíva',
        code: 'Kód',
        link: 'Odkaz',
        linkPrompt: 'Zadejte URL odkazu',
        headings: 'Nadpisy',
        quote: 'Citovat',
        bulletedList: 'Odrážkový seznam',
        numberedList: 'Číslovaný seznam',
        addComponent: 'Přidat součástku',
        richText: 'Rich Text',
        markdown: 'Markdown'
      },
      image: {
        choose: 'Vyberte obrázek',
        chooseMultiple: 'Vyberte obrázky',
        chooseUrl: 'Přidat z URL',
        replaceUrl: 'Nahradit z URL',
        promptUrl: 'Zadejte URL obrázku',
        chooseDifferent: 'Vyberte jiný obrázek',
        addMore: 'Přidat další obrázky',
        remove: 'Odstranit obrázek',
        removeAll: 'Odstranit všechny obrázky'
      },
      file: {
        choose: 'Vyberte soubor',
        chooseUrl: 'Přidat z URL',
        chooseMultiple: 'Vyberte soubory',
        replaceUrl: 'Nahradit z URL',
        promptUrl: 'Zadejte URL souboru',
        chooseDifferent: 'Vyberte jiný soubor',
        addMore: 'Přidat další soubory',
        remove: 'Odebrat soubor',
        removeAll: 'Odstranit všechny soubory'
      },
      unknownControl: {
        noControl: "Žádné ovládání pro widget '%{widget}'."
      },
      unknownPreview: {
        noPreview: "Žádný náhled pro widget '%{widget}'."
      },
      headingOptions: {
        headingOne: 'Nadpis 1',
        headingTwo: 'Nadpis 2',
        headingThree: 'Nadpis 3',
        headingFour: 'Nadpis 4',
        headingFive: 'Nadpis 5',
        headingSix: 'Nadpis 6'
      },
      datetime: {
        now: 'Teď',
        clear: 'Vymazat'
      },
      list: {
        add: 'Přidat',
        addType: 'Přidat'
      }
    }
  },
  mediaLibrary: {
    mediaLibraryCard: {
      draft: 'Koncept',
      copy: 'Kopírovat',
      copyUrl: 'Kopírovat URL',
      copyPath: 'Kopírovat cestu',
      copyName: 'Kopírovat název',
      copied: 'Zkopírováno'
    },
    mediaLibrary: {
      onDelete: 'Chcete skutečně vymazat označená média?',
      fileTooLarge: 'Soubor je příliš velký.\nSoubor musí být menší než %{size} kB.'
    },
    mediaLibraryModal: {
      loading: 'Načítání…',
      noResults: 'Nic nenalezeno.',
      noAssetsFound: 'Média nenalezena.',
      noImagesFound: 'Obrázky nenalezeny.',
      private: 'Soukromé ',
      images: 'Obrázky',
      mediaAssets: 'Média',
      search: 'Hledat…',
      uploading: 'Nahrávání…',
      upload: 'Nahrát nový',
      download: 'Stáhnout',
      deleting: 'Vymazávání…',
      deleteSelected: 'Smazat označené',
      chooseSelected: 'Vybrat označené'
    }
  },
  ui: {
    default: {
      goBackToSite: 'Vrátit se na stránku'
    },
    errorBoundary: {
      title: 'Chyba',
      details: 'Nastala chyba – prosím ',
      reportIt: 'nahlašte ji.',
      detailsHeading: 'Detaily',
      privacyWarning: 'Při otevření problému budou předvyplněny ladící data a chybová zpráva.\nProsím zkontrolujte, jestli jsou informace správné, a případně odstraňte citlivé údaje.',
      recoveredEntry: {
        heading: 'Nalezený dokument',
        warning: 'Prosím zkopírujte dokument do schránky před tím než odejte z této stránky!',
        copyButtonLabel: 'Zkopírovat do schránky'
      }
    },
    settingsDropdown: {
      logOut: 'Odhlásit'
    },
    toast: {
      onFailToLoadEntries: 'Chyba při načítání položky: %{details}',
      onFailToLoadDeployPreview: 'Chyba při načítání náhledu: %{details}',
      onFailToPersist: 'Chyba při ukládání položky: %{details}',
      onFailToDelete: 'Chyba při vymazávání položky: %{details}',
      onFailToUpdateStatus: 'Chyba při změně stavu položky: %{details}',
      missingRequiredField: 'Vynechali jste povinné pole. Prosím vyplňte ho.',
      entrySaved: 'Položka uložena',
      entryPublished: 'Položka publikována',
      entryUnpublished: 'Publikování položky zrušeno',
      onFailToPublishEntry: 'Chyba při publikování položky: %{details}',
      onFailToUnpublishEntry: 'Chyba při rušení publikování položky: %{details}',
      entryUpdated: 'Stav položky byl změněn',
      onDeleteUnpublishedChanges: 'Nepublikované změny byly smazány',
      onFailToAuth: '%{details}',
      onLoggedOut: 'Byli jste odhlášeni, prosím zálohujte všechna data a znova se přihlašte',
      onBackendDown: 'Backend zaznamenal výpadek. Podívejte se do %{details} pro více informací.'
    }
  },
  workflow: {
    workflow: {
      loading: 'Načítání položek',
      workflowHeading: 'Schvalovací proces',
      newPost: 'Nová položka',
      description: '%{smart_count} čeká na schválení, %{readyCount} připraven k publikaci. |||| %{smart_count} čeká na schválení, %{readyCount} připraveno k publikaci. ',
      dateFormat: 'MMMM D'
    },
    workflowCard: {
      lastChange: '%{date} (%{author})',
      lastChangeNoAuthor: '%{date}',
      lastChangeNoDate: '%{author}',
      deleteChanges: 'Vymazat změny',
      deleteNewEntry: 'Vymazat novou položku',
      publishChanges: 'Publikovat změny',
      publishNewEntry: 'Publikovat novou položku'
    },
    workflowList: {
      onDeleteEntry: 'Opravdu chcete smazat tuto položku?',
      onPublishingNotReadyEntry: 'Pouze položky se stavem "Připraveno" mohou být publikovány. Pro umožnění publikace musíte přetáhnout kartu do sloupce "Připraveno"',
      onPublishEntry: 'Opravdu chcete publikovat tuto položku?',
      draftHeader: 'Koncepty',
      inReviewHeader: 'V revizi',
      readyHeader: 'Připraveno',
      currentEntries: '%{smart_count} položka |||| %{smart_count} položek'
    }
  }
};
export default cs;